module.exports = __webpack_public_path__ + "static/media/OP_0023_corporate-01 (2).f1285263.png";